export default __webpack_public_path__ + "static/media/adding_data_item.46953592.gif";